import { Button } from '../common/Button';
import { getCatalogText } from '../../utils/catalogText';

export function CatalogError({ error, retry }: { error: 'loadError' | 'partialError' | null; retry: () => void }) {
  const text = getCatalogText();
  if (!error) return null;
  return <div role="alert" className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800">
    <p className="mb-4 text-gray-700 dark:text-gray-200">{text[error]}</p>
    <Button onClick={retry}>{text.retry}</Button>
  </div>;
}
